import { firestoreToObj } from '@pop-common/db/firestore-to-obj/firestore-to-obj';
import { collection } from 'firebase/firestore/lite';

import { db } from './firebase';
import { getCollectionPath, GetCollectionPathInput } from './get-collection-path';

export interface GetCollectionRefInput extends GetCollectionPathInput {
  actor?: string;
  skipConverter?: boolean;
}

export const getCollectionRef = async <T extends object>({ Deserializer, skipConverter }: GetCollectionRefInput) => {
  const collectionPath = await getCollectionPath({ Deserializer });

  let collectionRef = collection(db, collectionPath);
  if (skipConverter === true) {
    return collectionRef;
  }

  collectionRef = collectionRef.withConverter({
    toFirestore: (obj: object) => obj,
    fromFirestore: (snapshot) => {
      return firestoreToObj({ snapshot, Deserializer }) as T;
    },
  });
  return collectionRef;
};
